(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require(undefined));
	else if(typeof define === 'function' && define.amd)
		define(["plesk-ui-library"], factory);
	else if(typeof exports === 'object')
		exports["Jsw"] = factory(require(undefined));
	else
		root["Jsw"] = factory(root[undefined]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 178);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/* no static exports found */
/* all exports used */
/*!*******************************************!*\
  !*** external {"amd":"plesk-ui-library"} ***!
  \*******************************************/
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),

/***/ 116:
/* no static exports found */
/* all exports used */
/*!*******************************************!*\
  !*** ./app/view-switcher/ViewSwitcher.js ***!
  \*******************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _uiLibrary = __webpack_require__(/*! @plesk/ui-library */ 0);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

var ViewSwitcher = function (_Component) {
    _inherits(ViewSwitcher, _Component);

    function ViewSwitcher(props) {
        _classCallCheck(this, ViewSwitcher);

        var _this = _possibleConstructorReturn(this, (ViewSwitcher.__proto__ || Object.getPrototypeOf(ViewSwitcher)).call(this, props));

        _this.handleTogglePopover = function () {
            if (!_this.state.welcomeMode) {
                _this.setState({ popoverVisible: !_this.state.popoverVisible });
            }
        };

        _this.handleHideSwitcher = function () {
            var locale = _this.context.locale;
            var hideSwitcherUrl = _this.props.hideSwitcherUrl;


            Jsw.messageBox.show({
                type: Jsw.messageBox.TYPE_YESNO,
                subtype: 'toggle',
                text: locale.lmsg('confirmationBoxText'),
                description: locale.lmsg('confirmationBoxDescription'),
                buttonTitles: {
                    yes: locale.lmsg('confirmationBoxButtonYes'),
                    no: locale.lmsg('confirmationBoxButtonNo')
                },
                onYesClick: function onYesClick() {
                    _this.setState({ visible: false });
                    new Ajax.Request(hideSwitcherUrl, { method: 'post' });
                }
            });
        };

        _this.handleChangeView = function () {
            var changeViewUrl = _this.props.changeViewUrl;


            new Ajax.Request(changeViewUrl, {
                method: 'post',
                onSuccess: function onSuccess(transport) {
                    var redirect = transport.responseJSON.redirect;

                    if (redirect) {
                        Jsw.redirect(redirect);
                    }
                }
            });
        };

        _this.handleOpenLearnMore = function () {
            if (_this.state.welcomeMode) {
                _this.disableWelcomeMode();
            }

            Jsw.redirect(_this.props.learnMoreUrl);
        };

        _this.handleClosePopover = function () {
            setTimeout(function () {
                _this.setState({ popoverVisible: false });

                if (_this.state.welcomeMode) {
                    _this.setState({ welcomeMode: false });
                    _this.disableWelcomeMode();
                }
            }, 0);
        };

        _this.state = {
            visible: true,
            popoverVisible: props.isWelcomeMode,
            welcomeMode: props.isWelcomeMode
        };
        return _this;
    }

    _createClass(ViewSwitcher, [{
        key: 'disableWelcomeMode',
        value: function disableWelcomeMode() {
            new Ajax.Request(this.props.disableWelcomeModeUrl, { method: 'post' });
        }
    }, {
        key: 'renderActionMessage',
        value: function renderActionMessage() {
            var isPowerUserPanel = this.props.isPowerUserPanel;


            var actionMessage = (0, _uiLibrary.createElement)(_uiLibrary.Translate, {
                content: 'actionMessage',
                params: {
                    switchLink: (0, _uiLibrary.createElement)(
                        'a',
                        {
                            className: 'js-switch-view',
                            onClick: this.handleChangeView
                        },
                        (0, _uiLibrary.createElement)(_uiLibrary.Translate, {
                            content: this.state.welcomeMode ? 'welcomeSwitchView' : 'switchView',
                            params: { view: (0, _uiLibrary.createElement)(_uiLibrary.Translate, { content: isPowerUserPanel ? 'serviceProviderView' : 'powerUserView' }) }
                        })
                    ),
                    helpLink: (0, _uiLibrary.createElement)(
                        'a',
                        { onClick: this.handleOpenLearnMore },
                        (0, _uiLibrary.createElement)(_uiLibrary.Translate, { content: 'learnMore' })
                    )
                }
            });

            if (this.state.welcomeMode) {
                return (0, _uiLibrary.createElement)(_uiLibrary.Translate, {
                    content: isPowerUserPanel ? 'welcomePowerUser' : 'welcomeProviderView',
                    params: { action: actionMessage }
                });
            }

            return actionMessage;
        }
    }, {
        key: 'renderSwitcherPopover',
        value: function renderSwitcherPopover(target) {
            var _props = this.props,
                isPowerUserPanel = _props.isPowerUserPanel,
                showPowerUserViewWarning = _props.showPowerUserViewWarning;


            return (0, _uiLibrary.createElement)(
                _uiLibrary.Popover,
                {
                    visible: this.state.popoverVisible,
                    intent: 'warning',
                    target: target,
                    title: (0, _uiLibrary.createElement)(_uiLibrary.Translate, { content: 'title' }),
                    placement: 'top-right',
                    onClose: this.handleClosePopover,
                    canCloseOnOutsideClick: !this.state.welcomeMode,
                    canCloseOnEscapePress: !this.state.welcomeMode
                },
                (0, _uiLibrary.createElement)(_uiLibrary.Translate, {
                    content: 'currentViewMessage',
                    params: { view: (0, _uiLibrary.createElement)(_uiLibrary.Translate, { content: isPowerUserPanel ? 'powerUserView' : 'serviceProviderView' }) }
                }),
                (0, _uiLibrary.createElement)(
                    'p',
                    null,
                    this.renderActionMessage()
                ),
                showPowerUserViewWarning && (0, _uiLibrary.createElement)(
                    'span',
                    null,
                    (0, _uiLibrary.createElement)('i', { className: 'icon-attention-tr' }),
                    ' ',
                    (0, _uiLibrary.createElement)(_uiLibrary.Translate, { content: 'powerUserViewWarning' })
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            if (!this.state.visible) {
                return null;
            }

            return (0, _uiLibrary.createElement)(
                'div',
                { className: 'view-switcher' },
                (0, _uiLibrary.createElement)('span', { className: 'close', onClick: this.handleHideSwitcher }),
                (0, _uiLibrary.createElement)(
                    'a',
                    { href: '#', onClick: this.handleTogglePopover },
                    (0, _uiLibrary.createElement)('i', { className: 'icon-nav-navigation' }),
                    this.renderSwitcherPopover((0, _uiLibrary.createElement)(_uiLibrary.Translate, { content: 'title' }))
                )
            );
        }
    }]);

    return ViewSwitcher;
}(_uiLibrary.Component);

ViewSwitcher.propTypes = {
    isPowerUserPanel: _uiLibrary.PropTypes.bool.isRequired,
    showPowerUserViewWarning: _uiLibrary.PropTypes.bool.isRequired,
    learnMoreUrl: _uiLibrary.PropTypes.string.isRequired,
    hideSwitcherUrl: _uiLibrary.PropTypes.string.isRequired,
    disableWelcomeModeUrl: _uiLibrary.PropTypes.string,
    changeViewUrl: _uiLibrary.PropTypes.string.isRequired,
    isWelcomeMode: _uiLibrary.PropTypes.bool.isRequired
};
ViewSwitcher.defaultProps = {
    disableWelcomeModeUrl: ''
};
ViewSwitcher.contextTypes = {
    locale: _uiLibrary.PropTypes.object
};

exports.default = ViewSwitcher;

/***/ }),

/***/ 178:
/* no static exports found */
/* all exports used */
/*!************************************!*\
  !*** ./app/view-switcher/index.js ***!
  \************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _uiLibrary = __webpack_require__(/*! @plesk/ui-library */ 0);

var _ViewSwitcher = __webpack_require__(/*! ./ViewSwitcher */ 116);

var _ViewSwitcher2 = _interopRequireDefault(_ViewSwitcher);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

module.exports = function (container, _ref) {
    var locale = _ref.locale,
        props = _objectWithoutProperties(_ref, ['locale']);

    (0, _uiLibrary.render)((0, _uiLibrary.createElement)(
        _uiLibrary.LocaleProvider,
        { messages: locale },
        (0, _uiLibrary.createElement)(_ViewSwitcher2.default, props)
    ), container);
};

/***/ })

/******/ });
});


// WEBPACK FOOTER //
// javascript/app/view-switcher.js